// Чистая логика выбора элементов для генерации.

/**
 * Переключает элемент в выборе с учётом лимита режима.
 *
 * Выбор упорядочен: порядок = порядок добавления, он же уходит в
 * `referenceElementIds` — Kie раскладывает элементы по порядку, а промпт
 * ссылается на них по `@name`. Переполнение отбрасывается, а не вытесняет
 * ранний выбор: тихая замена выглядела бы как «клик не сработал».
 */
export function toggleElementId(
    selected: readonly string[],
    elementId: string,
    maxElements: number,
): string[] {
    if (selected.includes(elementId)) return selected.filter((id) => id !== elementId);
    if (selected.length >= maxElements) return [...selected];
    return [...selected, elementId];
}

/**
 * Отбрасывает id, которых уже нет в библиотеке (элемент удалили в другой
 * вкладке), и обрезает выбор до текущего лимита режима — при переключении на
 * режим с меньшим лимитом хвост не должен молча уехать в генерацию.
 */
export function reconcileSelection(
    selected: readonly string[],
    availableIds: Iterable<string>,
    maxElements: number,
): string[] {
    const available = new Set(availableIds);
    const kept = selected.filter((id) => available.has(id));
    return kept.length > maxElements ? kept.slice(0, maxElements) : kept;
}
